class CardVariantSelector extends window.BAO.CustomElement() {
	connectedCallback() {
		super.connectedCallback();

		this.handleVariantSelection = this.handleVariantSelection.bind(this);
		this.findSelectedVariant = this.findSelectedVariant.bind(this)

		const variantsElement = this.els?.variants?.element;
		if (!variantsElement) {
			console.error("Variants element not found");
			return;
		}
		try {
			this.variants = JSON.parse(variantsElement.innerHTML);
		} catch (error) {
			console.error("Failed to parse variants:", error);
			this.variants = [];
		}
	}

	setupListeners() {
		super.setupListeners();

		this.form = this.els?.form?.element;
		this.fieldsetOptions = this.els?.optionList?.selector;

		if (this.form) {
			this.listeners.add(this.form, 'change', () => {
				const selectedVariant = this.findSelectedVariant();

				if (selectedVariant) {
					this.addSelectedVariantToCart(selectedVariant);
				}
			});
		} else {
			console.warn("Form element not found");
		}
	}

	async handleVariantSelection() {
		const selectedVariant = this.findSelectedVariant();

		if (!selectedVariant) {
			console.warn("No valid variant selected");
			return;
		}

		try {
			await this.addSelectedVariantToCart(selectedVariant);
		} catch (error) {
			console.error("Error adding variant to cart:", error);
		}
	}

	async addSelectedVariantToCart(variant) {
		const cartRefreshEvent = new CustomEvent('cartDrawer:refreshed');
		const formData = {
			items: [
				{
					id: variant.id,
					quantity: 1,
				},
			],
		};

		try {
			const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify(formData),
			});

			if (!response.ok) {
				throw new Error(`Failed to add to cart: ${response.statusText}`);
			}

			document.dispatchEvent(cartRefreshEvent);

			return await response.json();
		} catch (error) {
			console.error("Error adding variant to cart:", error);
		}
	}

	findSelectedVariant() {
		const backInStockPopup = document.querySelector('.js-bis');
		const selectedOptions = this.selectedOptionValues;
		const matchingVariant = this.variants.find((variant) =>
			variant.options.every((option) => selectedOptions.includes(option))
		);

		if (!matchingVariant.available) {
			backInStockPopup.dataset.variantId = matchingVariant.id;
			this.backInStock(true);

			return false;
		}

		if (!matchingVariant || !matchingVariant.available) {
			console.warn("Selected variant is unavailable");
			return null;
		}

		return matchingVariant;
	}


	backInStock(state) {
		const popup = document.querySelector('.js-bis');
		if (!popup) return;

		const closeEls = document.querySelectorAll('.js-close-bis');

		if (state) {
			popup.classList.add('bis--visible');
			document.body.classList.add('is-bis-visible');
		} else {
			popup.classList.remove('bis--visible', 'bis--success');
			document.body.classList.remove('is-bis-visible');
		}

		closeEls.forEach(function (el) {
			el.addEventListener('click', function (e) {
				e.preventDefault();
				popup.classList.remove('bis--visible', 'bis--success');
				document.body.classList.remove('is-bis-visible');
			});
		});
	}

	get selectedOptionValues() {
		if (!this.fieldsetOptions) return [];

		return Array.from(
			this.querySelectorAll(`${this.fieldsetOptions} input:checked`)
		).map(({ dataset }) => dataset.value);
	}
}


if (!customElements.get('card-variant-selector')) {
	customElements.define('card-variant-selector', CardVariantSelector);
}
